import {
    AfterViewInit,
    ChangeDetectorRef,
    Directive,
    ElementRef,
} from '@angular/core';

@Directive({
    selector: '[truncateTooltip]',
    exportAs: 'truncateTooltip',
})
export class TruncateTooltipDirective implements AfterViewInit {
    isEllipsis = true;
    constructor(private cdr: ChangeDetectorRef, private el: ElementRef) {}
    ngAfterViewInit(): void {
        this.updateEllipsis();
        // Update isEllipsis when the window is resized
        window.addEventListener('resize', this.updateEllipsis.bind(this));
    }

    private updateEllipsis(): void {
        const element = this.el.nativeElement;
        this.isEllipsis = element.scrollWidth > element.clientWidth;
        this.cdr.detectChanges();
        console.log({'nativeElement': this.el.nativeElement, 'clientWidth': element.clientWidth, 'scrollWidth': element.scrollWidth, 'isEllipsis': this.isEllipsis})
    }

    ngOnDestroy(): void {
        // Remove the event listener when the directive is destroyed
        window.removeEventListener('resize', this.updateEllipsis.bind(this));
    }
}
